/**
 * Global textarea auto-resize module using event delegation
 */

export function initTextareaAutoResize() {
    document.addEventListener('input', function(event) {
        if (event.target && event.target.classList.contains('resize-textarea')) {
            const textarea = event.target;
            textarea.style.height = 'auto';
            textarea.style.height = (textarea.scrollHeight) + 'px';
        }
    });

    // Initial resize for textareas with content on page load
    const textareas = document.querySelectorAll('.resize-textarea');
    textareas.forEach(textarea => {
        if (textarea.value) {
            textarea.style.height = 'auto';
            textarea.style.height = (textarea.scrollHeight) + 'px';
        }
    });
}
